export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getCommunityList: function getCommunityList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/community/post/list",
        method: "get",
        params: data
      });
    },
    //标签列表
    getCommunityTagList: function getCommunityTagList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/community/post_tag/list",
        method: "get",
        params: data
      });
    },
    //分类列表
    getCommunityCategoryList: function getCommunityCategoryList(params) {
      return request({
        url: "/api/v1/admin/community/post_category/list",
        method: "get",
        params: params
      });
    },
    //社区详情
    getCommunityDetail: function getCommunityDetail(id) {
      return request({
        url: "/api/v1/admin/community/post/" + id,
        method: "get"
      });
    },
    //更新社区内容
    updateCommunity: function updateCommunity(data) {
      return request({
        url: "/api/v1/admin/community/post/update",
        method: "post",
        data: data
      });
    },
    //审核社区
    auditCommunity: function auditCommunity(data) {
      return request({
        url: "/api/v1/admin/community/post/audit",
        method: "post",
        data: data
      });
    },
    //删除社区单条信息
    delCommunity: function delCommunity(id) {
      return request({
        url: "/api/v1/admin/community/post/delete",
        method: "post",
        data: {
          id: id
        }
      });
    },
    //创建社区标签
    addCommunityTag: function addCommunityTag() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/community/post_tag/create",
        method: "post",
        data: data
      });
    },
    //更新标签
    updateCommunityTag: function updateCommunityTag() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/community/post_tag/update",
        method: "post",
        data: data
      });
    },
    //删除标签
    deleteCommunityTag: function deleteCommunityTag(id) {
      return request({
        url: "/api/v1/admin/community/post_tag/delete",
        method: "post",
        data: {
          id: id
        }
      });
    },
    //模拟推荐列表
    getSimulationList: function getSimulationList(params) {
      return request({
        url: "/api/v3/admin/post/list",
        method: "get",
        params: params
      });
    },
    getSimulationUserInfo: function getSimulationUserInfo(params) {
      return request({
        url: "/api/v3/admin/post/userInfo",
        method: "get",
        params: params
      });
    },
    getUserPostLog: function getUserPostLog(params) {
      return request({
        url: "/api/v1/admin/community/post/user_post_history",
        method: "get",
        params: params
      });
    }
  };
});